<script>
import appConfig from '@src/app.config'
import Layout from '@layouts/main'
import PageHeader from '@components/page-header'
import DatatableRates from '@components/datatablegn/DatatableRates'
import { axiosGetPost } from '@router/axiosGetPost'
import { downloadRequest } from '@components/downloadRequest'
import AddRateLcl from '@/src/components/contract/AddRateLcl'
import HarborManager from '@components/contract/harbor-manager'
import SurchargeManager from '@components/contract/surcharge-manager'
import CarrierManager from '@components/contract/carrier-manager'
import RequestInfo from '@/src/components/request/requestInfo'

export default {
  page: {
    title: 'Reviews Good / Fail LCL',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  components: {
    Layout,
    PageHeader,
    DatatableRates,
    AddRateLcl,
    HarborManager,
    SurchargeManager,
    CarrierManager,
    RequestInfo,
  },
  data() {
    return {
      request_id: this.$route.params.id,
      moduleT: 'LCL',
      title: 'Reviews Good / Fail LCL',
      loadingDataRates: false,
      loadingDataFailRates: false,
      loadingDataSurcharge: false,
      loadingDataFailSurcharge: false,
      loadedSurcharge: false,
      loadingBTab: false,
      isTesting: false,
      dataRates: [[]],
      dataFailRates: [[]],
      items: [
        {
          text: 'Barracuda',
          href: '/',
        },
        {
          text: 'Accounts LCL',
          href: '/accounts',
          active: true,
        },
        {
          text: 'Good - Fail',
          active: true,
        },
      ],
      modalComponent: null,
      modalTitle: 'Status',
      modalError: null,
      modalErrorShow: false,
      showModal: false,
      historyData: [],
      loadingData: false,
    }
  },
  computed: {},
  created() {
    this.request_id = this.$route.params.id
    if (this.isTesting) {
      this.testData()
    } else {
      this.fetchData()
    }
    this.$root.$on('update_table', (type, table = []) => {
      table.forEach((element) => {
        this.callDatatable(type, element)
      })
    })
  },
  mounted() {},
  methods: {
    testData() {
      this.loadingDataRates = false
    },
    fetchData() {
      this.callDatatable('rates', 'good')
      this.callDatatable('rates', 'fail')
    },
    callDatatable(table, mode) {
      let loadings = {
        rates: { good: 'loadingDataRates', fail: 'loadingDataFailRates' },
      }
      let variable = {
        rates: { good: 'dataRates', fail: 'dataFailRates' },
      }
      this[loadings[table][mode]] = true
      axiosGetPost('post', 'contractsLcl/datatables/' + this.request_id, {
        mode: mode,
      }).then((response) => {
        let data = response.data
        console.log(data)
        this[variable[table][mode]] = data.table
        this[loadings[table][mode]] = false
        this.showModal = false
        return data
      })
    },
    downloadFileRequest(id) {
      downloadRequest(id, 'LCL')
    },
    addRow(dataRow) {
      console.log(dataRow)
      this.showModal = true
      this.loadingData = true
      this.modalComponent = 'AddRateLcl'
      this.modalTitle = 'Add / Include Rate'
      this.loadingData = false
    },
    addVariation(type = 'harbors') {
      this.showModal = true
      this.modalComponent =
        type == 'harbors' ? 'HarborManager' : 'SurchargeManager'
      this.modalTitle =
        'Add Variation ' + (type == 'harbors' ? 'Harbors' : 'Surcharges')
    },
    showCarrierManager() {
      this.showModal = true
      this.modalComponent = 'CarrierManager'
      this.modalTitle = 'Carriers Manager'
    },
    saveModal() {
      this.showModal = false
    },
  },
}
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="form-group row">
              <div class="col-md-3">
                <h4 class="header-title mt-0 mb-1"
                  >Failure Review - Request:
                  {{ moduleT + ' - ' + request_id }}</h4
                >
              </div>
              <div class="mb-md-2 col-md-8">
                <button
                  class="btn btn-sm my-0 btn-outline-secondary"
                  title="Download File"
                  @click="downloadFileRequest(request_id)"
                  >Download File Rq
                  <i class="uil uil-cloud-download"></i> </button
                >&nbsp;
                <button
                  class="btn btn-sm my-0 btn-outline-secondary"
                  title="Add Rates"
                  @click="addRow('addRate')"
                  >Add Rate
                  <i class="uil uil-plus"></i>
                </button>
                &nbsp;
                <button
                  class="btn btn-sm my-0 btn-outline-secondary"
                  title="Harbors Manage"
                  @click="addVariation('harbors')"
                  >Harbor Manage
                  <i class="uil uil-plus"></i>
                </button>
                &nbsp;
                <button
                  class="btn btn-sm my-0 btn-outline-secondary"
                  title="Surcharge Manager"
                  @click="addVariation('chargers')"
                  >Surcharges Manager
                  <i class="uil uil-plus"></i>
                </button>
                &nbsp;
                <button
                  class="btn btn-sm my-0 btn-outline-secondary"
                  title="Carrier Manager"
                  @click="showCarrierManager()"
                  >Carrier Manager
                  <i class="uil uil-plus"></i>
                </button>
                &nbsp;
                <router-link
                  class="btn btn-sm my-0 btn-outline-primary"
                  title="Add Surcharge"
                  href="#"
                  :to="{
                    name: 'account_detail_lcl',
                    params: {
                      id: request_id,
                    },
                  }"
                  >Account Details
                  <i class="uil uil-up"></i>
                </router-link>
                &nbsp;
                <router-link
                  class="btn btn-sm my-0 btn-outline-secondary"
                  title="Review Suggestions"
                  href="#"
                  :to="{
                    name: 'reviews_module_lcl',
                    params: {
                      id: request_id,
                    },
                  }"
                >
                  Review Suggestions
                  <i class="uil uil-search"></i>
                </router-link>
              </div>
            </div>
            <RequestInfo :request-id="request_id" :module="'LCL'" />
            <div class="row">
              <div class="mb-md-2 col-md-12">
                <b-tabs align="center">
                  <!-- Fail Rates Tab **************************************************************  -->
                  <b-tab active>
                    <template #title>
                      <i
                        class="uil uil-times-circle"
                        style="font-size: 13px; color: brown"
                      ></i>
                      &nbsp; <strong>Fail Rates</strong>
                    </template>
                    <div
                      v-if="loadingDataFailRates"
                      class="row align-items-center justify-content-center"
                      style="height: 300px"
                    >
                      <div class="col-12 col-md-8 text-center">
                        <b-spinner
                          label="Loading..."
                          variant="secondary"
                          class="ml-3"
                        ></b-spinner>
                      </div>
                    </div>
                    <div v-else>
                      <span
                        class="uil uil-thumbs-down mt-2"
                        style="color: brown"
                      >
                        &nbsp; </span
                      ><strong
                        >Rates Failed: {{ dataFailRates[0].length }}</strong
                      >
                      <br />
                      <DatatableRates
                        :table-data="dataFailRates"
                        type-table="fail"
                        :request-id="request_id"
                        :inc-options="[
                          'editFails',
                          'multipleeditfails',
                          'delete',
                        ]"
                        :variation-cell="['origin', 'destiny']"
                        checkbox-id="id"
                        module="LCL"
                      />
                    </div>
                  </b-tab>
                  <!-- Good Rates Tab **************************************************************  -->
                  <b-tab>
                    <template #title>
                      <i
                        class="uil uil-check-circle"
                        style="font-size: 13px; color: forestgreen"
                      ></i>
                      &nbsp;
                      <strong>Good Rates</strong>
                    </template>
                    <div
                      v-if="loadingDataRates"
                      class="row align-items-center justify-content-center"
                      style="height: 300px"
                    >
                      <div class="col-12 col-md-8 text-center">
                        <b-spinner
                          label="Loading..."
                          variant="secondary"
                          class="ml-3"
                        ></b-spinner>
                      </div>
                    </div>
                    <div v-else>
                      <span
                        class="uil uil-thumbs-up mt-2"
                        style="color: forestgreen"
                      >
                        &nbsp; </span
                      ><strong>Good Rates: {{ dataRates[0].length }}</strong>
                      <DatatableRates
                        :table-data="dataRates"
                        type-table="good"
                        :request-id="request_id"
                        :inc-options="['edit', 'delete']"
                        module="LCL"
                      />
                    </div>
                  </b-tab>
                </b-tabs>
              </div>
            </div>
          </div>
        </div>
      </div>
      <b-modal
        id="modal-lg"
        ref="requestFcl"
        v-model="showModal"
        size="lg"
        :title="modalTitle"
        title-class="font-18"
      >
        <div
          v-if="loadingData"
          class="row align-items-center justify-content-center"
          style="height: 300px"
        >
          <div class="col-12 col-md-8 text-center">
            <b-spinner
              label="Loading..."
              variant="primary"
              class="ml-3"
            ></b-spinner>
          </div>
        </div>

        <div v-else-if="modalErrorShow === true">
          <div
            class="row align-items-center justify-content-center"
            style="height: 300px"
          >
            <div class="col-12 col-md-8 text-center">
              <feather type="frown" class="icon-xxl icon-dual-info"></feather>
              <h6 class="text-muted">{{ modalError }}</h6>
            </div>
          </div>
        </div>
        <AddRateLcl
          v-if="modalComponent === 'AddRateLcl' && loadingData === false"
          :request-id="request_id"
          loadTable
        />
        <HarborManager
          v-if="modalComponent === 'HarborManager' && loadingData === false"
        />
        <SurchargeManager
          v-if="modalComponent === 'SurchargeManager' && loadingData === false"
        />
        <CarrierManager
          v-if="modalComponent === 'CarrierManager' && loadingData === false"
        />
        <template v-slot:modal-footer>
          <b-button variant="light" @click="saveModal">Close</b-button>
          <b-button
            v-if="
              loadingData === false &&
                modalErrorShow === false &&
                modalComponent === ''
            "
            variant="primary"
            @click="saveModal"
          >
            OK
          </b-button>
        </template>
      </b-modal>
    </div>
  </Layout>
</template>
<style type="text/css">
.show .btn-success.dropdown-toggle {
  color: #010b55;
  background-color: #e9e9e9;
  border-color: #001add;
}

.text {
  font-family: helvetica;
  font-weight: bold;
  color: #71d90b;
}
</style>
